import React from 'react';
import { observer } from 'mobx-react';
import { pinnedPanelStore } from './pinnedPanelStore';

function PinnedPanelToggleButton({ scope }) {
	const isOpen = pinnedPanelStore.isOpen(scope);
	const count = pinnedPanelStore.getCount(scope);

	return (
		<button
			type="button"
			className={`ats-button-soft pinned-panel-toggle-button ${isOpen ? 'is-active' : ''}`}
			aria-pressed={isOpen}
			onClick={() => pinnedPanelStore.toggle(scope)}>
			<img src="/ats/icons/pin-note-icon.svg" alt="" width={16} height={16} />
			Pinned{count > 0 ? ` (${count})` : ''}
		</button>
	);
}

export default observer(PinnedPanelToggleButton);
